/**
 * COPPER ROAD FRONTEND - APP.JSX
 * Main application with React Router
 */

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import LoadingSpinner from './components/LoadingSpinner';

// Pages
import Home from './pages/Home';
import Trail from './pages/Trail';
import MapView from './pages/MapView';
import Partners from './pages/Partners';

import CheckIn from './pages/CheckIn';
import CheckInLanding from './pages/CheckInLanding';
import Badges from './pages/Badges';

import Register from './pages/Register';
import Login from './pages/Login';
import Profile from './pages/Profile';
import ScanPage from './pages/ScanPage';
import LandingPage from './pages/LandingPage';
import SocialCallback from './pages/SocialCallback';
import PrivacyPolicy from './pages/PrivacyPolicy';

// Protected route wrapper
function PrivateRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) return <LoadingSpinner />;
    return user ? children : <Navigate to="/login" replace />;
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
                    <Route path="/dashboard" element={<PrivateRoute><Home /></PrivateRoute>} />
                    <Route path="/trail" element={<PrivateRoute><Trail /></PrivateRoute>} />
                    <Route path="/scan" element={<ScanPage />} />
                    <Route path="/checkin" element={<PrivateRoute><CheckIn /></PrivateRoute>} />
                    <Route path="/checkin_manual" element={<PrivateRoute><CheckIn /></PrivateRoute>} />
                    <Route path="/checkin/:token" element={<PrivateRoute><CheckIn /></PrivateRoute>} />
                    <Route path="/map" element={<PrivateRoute><MapView /></PrivateRoute>} />
                    <Route path="/partners" element={<PrivateRoute><Partners /></PrivateRoute>} />
                    <Route path="/badges" element={<PrivateRoute><Badges /></PrivateRoute>} />
                    <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
                    <Route path="/auth/callback" element={<SocialCallback />} />

                    <Route path="*" element={
                        window.location.pathname.startsWith('/admin') 
                        ? null 
                        : <Navigate to="/" />
                    } />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

const styles = {
    loading: {
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', fontSize: 20, fontFamily: 'Georgia, serif', color: '#b8753d'
    }
};

export default App;
